import React, { useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface FileUploadProps {
    onFileUpload: (file: File) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ onFileUpload }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
    const { t } = useTranslation();
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      console.log('File selected:', file.name);
      onFileUpload(file);
    }
  };

  return (
    <>
        <Button as="label" 
            onClick={() => inputRef.current?.click()}
            variant="primary"
            className="w-100 w-auto d-flex justify-content-center align-items-center my-2"
            style={{height: '35px'}}> {t('uploadExcel')}
        </Button>
   
        <input
            type="file"
            ref={inputRef}
            onChange={handleUpload}
            style={{ visibility: 'hidden' }} // Hide input but keep it functional
        />
    </>
  );
};

export default FileUpload;
